"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.builder = void 0;

var builder_1 = require("../builder");

var container_1 = require("./container");

var compute_1 = require("./compute");

var config_1 = require("./config");

var networking_1 = require("./networking");

var storage_1 = require("./storage");

var rbac_1 = require("./rbac");

var security_1 = require("./security");

var api_1 = require("./api");

var _3rd_party_1 = require("./3rd-party");

exports.builder = new builder_1.ValidatorsDocsBuilder();
container_1.setupContainerValidators(exports.builder);
compute_1.setupComputeValidators(exports.builder);
config_1.setupConfigValidators(exports.builder);
networking_1.setupNetworkingValidators(exports.builder);
storage_1.setupStorageValidators(exports.builder);
rbac_1.setupRBACValidators(exports.builder);
security_1.setupSecurityValidators(exports.builder);
api_1.setupApiValidators(exports.builder);

_3rd_party_1.setup3rdParty(exports.builder);